/**
 * Random variables used in the app
 */
export const LOGIN_ROUTE_PATH = ''
export const SIGN_ROUTE_PATH = 'sign'
export const HOME_ROUTE_PATH = 'home'